var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 54,
    viewBox: "0 0 58 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2698_3690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0538 38.1337H15.8026L9.90442 14.0342H55.9644L50.0538 38.1337Z",
    fill: "white",
    stroke: "#474C55",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9426 46.1463H20.0315C17.6945 46.1463 15.8026 44.2544 15.8026 41.9174V38.1337L7.80239 5.44043H1.54565",
    stroke: "#474C55",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2942 52.3165C23.9947 52.3165 25.3731 50.938 25.3731 49.2376C25.3731 47.5372 23.9947 46.1587 22.2942 46.1587C20.5938 46.1587 19.2153 47.5372 19.2153 49.2376C19.2153 50.938 20.5938 52.3165 22.2942 52.3165Z",
    stroke: "#474C55",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4524 52.3165C46.1529 52.3165 47.5313 50.938 47.5313 49.2376C47.5313 47.5372 46.1529 46.1587 44.4524 46.1587C42.752 46.1587 41.3735 47.5372 41.3735 49.2376C41.3735 50.938 42.752 52.3165 44.4524 52.3165Z",
    stroke: "#474C55",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9282 26.5229C39.8255 26.5229 45.4169 20.9315 45.4169 14.0341C45.4169 7.13681 39.8255 1.54541 32.9282 1.54541C26.0308 1.54541 20.4395 7.13681 20.4395 14.0341C20.4395 20.9315 26.0308 26.5229 32.9282 26.5229Z",
    fill: "#813DB5",
    stroke: "#474C55",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9282 9.1875V18.8817",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0811 14.0342H37.7753",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2698_3690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.51,
    height: 53.8623,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon_cart.5fcf8c031523ff7408cee178c57f3c35.svg";
export { ForwardRef as ReactComponent };